import { render, staticRenderFns } from "./CheckResults.vue?vue&type=template&id=01d277d0&scoped=true"
import script from "./CheckResults.vue?vue&type=script&lang=js"
export * from "./CheckResults.vue?vue&type=script&lang=js"
import style0 from "./CheckResults.vue?vue&type=style&index=0&id=01d277d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d277d0",
  null
  
)

export default component.exports